export const createArrayToCountValue = (valueLength: number) => {
  return Array.from({ length: valueLength }, (_, index) => index);
};
